'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _components = require('../../components');

var _DefaultString = require('../../helpers/DefaultString');

var _ContactUsFeedback = require('./ContactUsFeedback.scss');

var _ContactUsFeedback2 = _interopRequireDefault(_ContactUsFeedback);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContactUsFeedback = function (_Component) {
  (0, _inherits3.default)(ContactUsFeedback, _Component);

  function ContactUsFeedback() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ContactUsFeedback);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ContactUsFeedback.__proto__ || (0, _getPrototypeOf2.default)(ContactUsFeedback)).call.apply(_ref, [this].concat(args))), _this), _this.onOk = function () {
      history.go(-2);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ContactUsFeedback, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: _ContactUsFeedback2.default.contactUsFeedback },
        _react2.default.createElement(
          'div',
          { className: _ContactUsFeedback2.default.title },
          _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.ContactUsTextOnly)
        ),
        _react2.default.createElement(
          'div',
          { className: _ContactUsFeedback2.default.message },
          _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.ContactUsFeedback)
        ),
        _react2.default.createElement(_components.BaseButton, { className: _ContactUsFeedback2.default.button, buttonString: _DefaultString.translations.Ok, onClick: this.onOk })
      );
    }
  }]);
  return ContactUsFeedback;
}(_react.Component);

exports.default = (0, _reactIntl.injectIntl)(ContactUsFeedback);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/ContactUsFeedback/ContactUsFeedback.js
// module id = 2003
// module chunks = 0